import styled, { css } from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  color: string;
}

export const Wrapper = styled.div`
  border-radius: 4px;
  font-family: ${FONTS.ROBOTO};
  font-size: 13px;
  padding: 7px 10px;
  color: ${COLORS.BLACK};
  strong {
    margin-right: 2px;
    color: ${COLORS.BLACK_BOLD};
  }
  ${(props: Props) => props.color && css`
    background: ${props.color};
  `}
`;
